import React, { Component, Fragment } from "react";
import QuizViewerModel from "./QuizViewerModel";
import Activity from "./activitiesUi/activity/model/Activity";
import ActivityUI from "./activitiesUi/activity/activityComponent/ActivityUI";
import ResultPage from "./activitiesUi/ResultPage";
import TFACtivityModel from "./activitiesUi/mcq/model/TFACtivityModel";
import ConnectActivity from "./activitiesUi/connect/model/ConnectActivity";
import WriteMissingWordsActivity from "./activitiesUi/writeMissingWords/model/WriteMissingWordsActivity";
import axios from "axios";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  withRouter,
} from "react-router-dom";
import WebExam from "../web/webExam";

import WebActivity from "../webActivity/webActivity";
import TFQModel from "./activitiesUi/mcq/model/TFQModel";
import WebResponsiveActivity from "../Responsive/webResponsiveActivity";
import ResultPageResponsive from "../ResultPageResponsive/ResultPageResponsive";
class QuizViewer extends Component {
  constructor() {
    super();
    this.mainContainer = React.createRef();
    this.currentSound = null;
  }

  state = {
    quizViwerModel: new QuizViewerModel(),
  };

  handleResize = () => {
    let { quizViwerModel } = this.state;

    var w = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || window.parent.innerWidth
    );
    var h = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || window.parent.innerHeight
    );
    var Width = h > w ? h : w;
    var Height = h > w ? w : h;

    let container = this.mainContainer.current;
    var scaleX = Width / container.offsetWidth;
    var scaleY = Height / container.offsetHeight;

    quizViwerModel.factor = scaleX > scaleY ? scaleY : scaleX;

    container.style.webkitTransform =
      "scale(" + quizViwerModel.factor + "," + quizViwerModel.factor + ")";
  };

  componentDidMount = () => {
    let { app } = this.props;
    let { quizViwerModel } = this.state;

    let url_string = window.location.href;
    let url = new URL(url_string);
    let quizId = url.searchParams.get("quizId");
    let userId = url.searchParams.get("userId");
    let topicId = url.searchParams.get("topicId");
    let courseId = url.searchParams.get("courseId");
    let showReport = url.searchParams.get("showReport");
    let isExam = url.searchParams.get("isExam");
    let topicTitle = url.searchParams.get("topicTitle");
    let dev = url.searchParams.get("dev");
    let dir = url.searchParams.get("dir");

    quizViwerModel.callbackData = {
      userId: userId,
      topicId: topicId,
      courseId: courseId,
      quizId: quizId,
      showReport: showReport,
      isExam: isExam,
      topicTitle: topicTitle,
      dev: dev,
      dir: dir,
    };

    quizViwerModel.callback = (report, callback) => {
      // if (userId == 0)
      {
        let formData = new FormData();

        formData.append("studentId", quizViwerModel.callbackData.userId);
        formData.append("topicId", quizViwerModel.callbackData.topicId);
        formData.append("itemId", quizViwerModel.callbackData.quizId);
        formData.append("courseId", quizViwerModel.callbackData.courseId);
        formData.append("points", quizViwerModel.getPoints());
        formData.append("report", report);
        formData.append("state", 1);
        formData.append("totalDegree", quizViwerModel.total);
        formData.append("studentDegree", quizViwerModel.degree);
        formData.append("totalTime", 411);

        axios({
          method: "post",
          url: "https://nafes.app/revision/revision-php/ws/user/StudentWS.php?method=updateItemReportTest4YouUnsequenceModeWithExamDetails",
          data: formData,

          headers: {
            "Content-type": "application/x-www-form-urlencoded",
          },
        }).then(function (response) {
          console.log(response);
          callback(response);
          console.log(response);
        });
        // .catch(function (error) {
        //     console.log(error);
        // });
      }
      // else {
      //     callback({})
      // }
    };

    app.showProgressContainer();
    if (
      quizViwerModel.callbackData.showReport &&
      quizViwerModel.callbackData.showReport == "true"
    ) {
      quizViwerModel.showResultPage = true;
      quizViwerModel.reviewMode = true;

      this.setState({});
      quizViwerModel.getItemReport(quizId, userId, (res) => {
        this.setState({});

        app.hideProgressContainer();
        // this.props.history.push("/result_page/true");
        this.props.history.push("/result_page_mobile/true");
      });
    } else {
      this.buildQuiz(quizId);
    }
  };

  retryQuiz = () => {
    let { app } = this.props;
    let { quizViwerModel } = this.state;

    quizViwerModel.activityArr = [];
    quizViwerModel.currentActivity = -1;
    quizViwerModel.reviewMode = false;
    quizViwerModel.showResultPage = false;
    quizViwerModel.callbackData.showReport = "false";
    this.buildQuiz(quizViwerModel.callbackData.quizId);
    app.showProgressContainer();
    this.setState({ quizViwerModel });
    // this.props.history.push("/activity_ui");
    this.props.history.push("/webResponsiveActivity");
  };

  buildQuiz = (quizId) => {
    let { app } = this.props;
    let { quizViwerModel } = this.state;
    quizViwerModel.getTest4You(quizId, (res) => {
      console.log(res.data);

      if (
        typeof res.data == "object" &&
        typeof res.data != null &&
        res.data.questionListJson.length != 0
      ) {
        let { questionListJson } = res.data;
        for (let i = 0; i < questionListJson.length; i++) {
          let activityObj = JSON.parse(questionListJson[i].questionJson);
          console.log(activityObj);

          //let activity=new WriteMissingWordsActivity()
          let activity = new Activity();
          if (activityObj.activityType == activity.CONNECT)
            activityObj.activityType = activity.COMPARE;
          activity = quizViwerModel.createActivityWithType(
            activityObj.activityType
          );
          activity.activityId = questionListJson[i].qId;
          activity.activityKey = questionListJson[i].qKey;
          activity.loList = questionListJson[i].loList;
          activity.catId = questionListJson[i].qCatId;
          activity.questionType = questionListJson[i].questionType;

          if (activityObj.test4you) {
            activity.initFromJsonTest4You(activityObj);
          }
          activity.activityIndex = i;
          quizViwerModel.activityArr.push(activity);
        }

        quizViwerModel.currentActivity = 0;
        console.log(quizViwerModel.activityArr);

        this.setState({ quizViwerModel });

        window.timeTakenTimer = window.setInterval(() => {
          quizViwerModel.timeTaken++;
        }, 1000);
      } else {
        document.write(
          "<h3 style='direction:rtl'>لا يوجد أسئلة في هذا الاختبار!<h3>"
        );
      }
      app.hideProgressContainer();
      if (
        quizViwerModel.callback.isExam == "false" ||
        !quizViwerModel.callback.isExam
      ) {
        this.props.history.push("/webResponsiveActivity");
      } else {
        this.props.history.push("/webExam");
      }
    });
  };

  scale = () => {
    let { quizViwerModel } = this.state;
    window.addEventListener("resize", this.handleResize);
    var w = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || window.parent.innerWidth
    );
    var h = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || window.parent.innerHeight
    );
    var Width = h > w ? h : w;
    var Height = h > w ? w : h;

    let container = this.mainContainer.current;
    var scaleX = Width / container.offsetWidth;
    var scaleY = Height / container.offsetHeight;

    quizViwerModel.factor = scaleX > scaleY ? scaleY : scaleX;
    container.style.webkitTransform =
      "scale(" + quizViwerModel.factor + "," + quizViwerModel.factor + ")";
  };

  render = () => {
    let { quizViwerModel } = this.state;

    let activity = new Activity();
    if (quizViwerModel.currentActivity != -1) {
      activity = quizViwerModel.activityArr[quizViwerModel.currentActivity];
    }

    let { selectedStyle } = quizViwerModel;

    return (
      <Fragment>
        <div ref={this.mainContainer} className="main-container">
          {/* {(!quizViwerModel.showResultPage) ?
                        <ActivityUI app={this.props.app} quizViewer={this} />
                        :
                        <ResultPage app={this.props.app} quizViewer={this} />
                    } */}

          <Switch>
            <Route path="/activity_ui">
              <ActivityUI app={this.props.app} quizViewer={this} />
            </Route>
            <Route path="/result_page/:showCharacter">
              <ResultPage app={this.props.app} quizViewer={this} />
            </Route>
            <Route path="/result_page_mobile/:showCharacter">
              <ResultPageResponsive app={this.props.app} quizViewer={this} />
            </Route>

            <Route path="/webExam">
              <WebExam app={this.props.app} quizViewer={this} />
            </Route>
            <Route path="/webActivity">
              <WebActivity app={this.props.app} quizViewer={this} />
            </Route>
            <Route path="/webResponsiveActivity">
              <WebResponsiveActivity app={this.props.app} quizViewer={this} />
            </Route>
          </Switch>
        </div>
      </Fragment>
    );
  };

  toArabicDigits = (num) => {
    var id = ["۰", "۱", "۲", "۳", "٤", "٥", "٦", "۷", "۸", "۹"];
    return num.replace(/[0-9]/g, function (w) {
      return id[+w];
    });
  };

  setCurrentSound = (sound) => {
    // console.log(sound)
    this.currentSound = sound;
  };

  stopCurrentSound = () => {
    if (this.currentSound != null) {
      this.currentSound.pause();
      this.currentSound.currentTime = 0;
      this.currentSound = null;
    }
  };
}

export default withRouter(QuizViewer);

//https://mobile.facebook.com/v10.0/dialog/oauth?access_token=EAADw927rIfABAEYaLM7MhgtnCi3mcuPWOfWtYbtHMA9h6cFLTNUed510tBZAIPIOZBgprDYcec0QNZBFJ5cEnJZC97e9EDfnW1cZB4dJwrMy7kQyqRaN2d43IWFTKqldTZCSV5ZBAf4L1vsQuZApqfj8GhOkRJiVu7nfZAs1WnZAuA7ZA2mf7YiAWtGYYV3ZAQh2rM6LqdhxDYocTQZDZD&app_id=264945508491760&cbt=1615374001904&channel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df1e481deb466ccc%26domain%3Dnafes.app%26origin%3Dhttps%253A%252F%252Fnafes.app%252Ff1cb974c0765c68%26relation%3Dopener&client_id=264945508491760&display=touch&domain=nafes.app&e2e=%7B%7D&fallback_redirect_uri=https%3A%2F%2Fnafes.app%2Frevision%2Frevision-react%2Fmobile%2Flayout%2Flogin&locale=en_US&logger_id=f2b74d518281af4&origin=2&redirect_uri=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df115ea67681607%26domain%3Dnafes.app%26origin%3Dhttps%253A%252F%252Fnafes.app%252Ff1cb974c0765c68%26relation%3Dopener%26frame%3Df260a1d813cf6d8&response_type=token%2Csigned_request%2Cgraph_domain&return_scopes=true&scope=public_profile%2Cemail&sdk=joey&version=v10.0
